import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../../components/Navbar/Navbar";
import "./Emails.scss";

import AuthContext from "../../context/AuthProvider";
import { useDispatch, useSelector } from "react-redux";
import { GhostExamListLoader } from "../../components/Loaders/GhostExamListLoader";
import { useMediaQuery } from "react-responsive";
import {
  refreshExamTabTable,
  setGlobalEmailFilter,
} from "../../store/slices/adminSlice";
import {EmailFilter} from "./EmailFilter";
import {EmailTable} from "../../components/Admins/EmailTable";
import {getSentEmails} from "../../store/actions/adminActions";

export const Emails = ({ isAdmin }) => {
  const useDesktopMediaQuery = () =>
    useMediaQuery({ query: "(min-width: 769px)" });

  const useTabletAndBelowMediaQuery = () =>
    useMediaQuery({ query: "(max-width: 768px)" });

  const Desktop = ({ children }) => {
    const isDesktop = useDesktopMediaQuery();
    return isDesktop ? children : null;
  };

  const TabletAndBelow = ({ children }) => {
    const isTabletAndBelow = useTabletAndBelowMediaQuery();
    return isTabletAndBelow ? children : null;
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleSetShow = () => setShow(true);

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const { user, isLoggedIn } = useContext(AuthContext);
  const { adminsdata } = useSelector((state) => state.admin);
  const dispatch = useDispatch();
  const [filterData, setFilterData] = useState({ search: "" });
  const [activeView, setActiveView] = useState(1);

  const handleGoToNext = (page) => {
    setCurrentPage((prev) => prev + 1);
  };

  const handleGoToPrev = () => {
    setCurrentPage((prev) => prev - 1);
  };

  const handleResetCurrentPage = () => {
    setCurrentPage((prev) => 1);
  };

  const handleSetFilter = (e) => {
    setFilterData({ ...filterData, [e.target.name]: e.target.value });
    // handleSearch();
  };

  const handleSearch = () => {
    const data = { pageSize, currentPage };

    data.isSearch = true;
    // if (filterData.search.length > 0) data.search = filterData.search;
    handleApiData(data);
  };

  const handleApiData = (data) => {
    const filters = JSON.parse(localStorage.getItem(`emailFilters`) || "{}");

    if (filters.searchFilter && filters.searchFilter.length > 0) {
      data.search = filters.searchFilter;
    }
    if (filters.sort && filters.sort.length > 0) {
      data.sort = filters.sort;
    } else {
      data.sort = "All Mail";
    }
    if (isAdmin && adminsdata.types.length === 0) data.is_filter = true;
    data.isAdmin = isAdmin;
    if (data.isSearch) {
      handleResetCurrentPage();
      data.currentPage = 1;
    }
    if(!data.isDelivery && data.isDelivery !== 0)
      data.isDelivery = (activeView === 2)?1:0;
    dispatch(getSentEmails(data));
  };
  function handleTabChange(tabIndex) {
    setCurrentPage(1);
    setActiveView(tabIndex);
      dispatch(refreshExamTabTable(0));
      handleApiData({ pageSize, currentPage, isDelivery: (tabIndex === 2)?1:0 });
  }


  useEffect(() => {
    handleApiData({ pageSize, currentPage });
  }, [pageSize, currentPage]);

  useEffect(() => {
    return () => {
      const payload = {
        searchFilter: "",
        sort: "",
      };
      dispatch(setGlobalEmailFilter(payload));
    };
  }, []);




  return (
    <>
      <div>{isAdmin ? "" : <Navbar />}</div>
      {/*<Desktop>*/}
        <div className="analysis-tab flag-cls test-analysis-div emails col-md-10 offset-md-1">
          {" "}
          <div className="flexy flexyM search-bar mt6">
            <div className="lisxt ">
              <Link to={"new"} className="menu-link btn-new-compose">
                <button  onClick={handleSearch}>New Email </button>
              </Link>
            </div>
          </div>
          <div className="tabs ">
            <button className={`tab ${activeView === 1 ? "active2" : ""}`} onClick={() => handleTabChange(1)}>
              Sent Mails
            </button>
            <button className={`tab ${activeView === 2 ? "active2" : ""}`} onClick={() => handleTabChange(2)} style={{ marginLeft: "20px" }}>
              Delivery Report
            </button>
          </div>
          {activeView === 1?(
              <>
          <EmailFilter
            handleClose={handleClose}
            show={show}
            Desktop={Desktop}
            TabletAndBelow={TabletAndBelow}
            handleSearch={handleSearch}
          />

          {adminsdata.loadingMail &&
            Array(pageSize)
              .fill()
              .map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <GhostExamListLoader></GhostExamListLoader>
                  </React.Fragment>
                );
              })}
          {!adminsdata.loadingMail && adminsdata.sentEmails && (
            <EmailTable
              globalFilter={filterData}
              onGlobalFilterChange={handleSearch}
              data={adminsdata.sentEmails}
              meta={adminsdata.meta}
              onGotoNextPage={handleGoToNext}
              onGotoPrevPage={handleGoToPrev}
              currentPage={currentPage}
              isAdmin={isAdmin}
              isDelivery={activeView}
            />)}
            </>):(
              <>
                <EmailFilter
                    handleClose={handleClose}
                    show={show}
                    Desktop={Desktop}
                    TabletAndBelow={TabletAndBelow}
                    handleSearch={handleSearch}
                />

                {adminsdata.loadingMail &&
                Array(pageSize)
                    .fill()
                    .map((item, index) => {
                      return (
                          <React.Fragment key={index}>
                            <GhostExamListLoader></GhostExamListLoader>
                          </React.Fragment>
                      );
                    })}
                {!adminsdata.loadingMail && adminsdata.sentEmails && (
                    <>
                      <EmailTable
                          globalFilter={filterData}
                          onGlobalFilterChange={handleSearch}
                          data={adminsdata.sentEmails}
                          meta={adminsdata.meta}
                          onGotoNextPage={handleGoToNext}
                          onGotoPrevPage={handleGoToPrev}
                          currentPage={currentPage}
                          isAdmin={isAdmin}
                          isDelivery={activeView}
                      />
                    </>
                    )}
              </>
          )}
        </div>
      {/*</Desktop>*/}
      {/*<TabletAndBelow>*/}
      {/*  <div className="flag-cls  mobile-ms">*/}
      {/*    {adminsdata.loadingMail &&*/}
      {/*      Array(pageSize)*/}
      {/*        .fill()*/}
      {/*        .map((item, index) => {*/}
      {/*          return (*/}
      {/*            <React.Fragment key={index}>*/}
      {/*              <GhostExamListMobileLoader></GhostExamListMobileLoader>*/}
      {/*            </React.Fragment>*/}
      {/*          );*/}
      {/*        })}*/}
      {/*    {!adminsdata.loadingMail && adminsdata.sentEmails && (*/}
      {/*      // <ExamAnalysis*/}
      {/*      //     globalFilter={filterData}*/}
      {/*      //     onGlobalFilterChange={handleSearch}*/}
      {/*      //     data={adminsdata.pastQuestions}*/}
      {/*      //     meta={adminsdata.questionsMeta}*/}
      {/*      //     onGotoNextPage={handleGoToNext}*/}
      {/*      //     onGotoPrevPage={handleGoToPrev}*/}
      {/*      //     currentPage={currentPage}*/}
      {/*      // />*/}
      {/*      <ExamCardAnalysis*/}
      {/*        globalFilter={filterData}*/}
      {/*        onGlobalFilterChange={handleSearch}*/}
      {/*        data={adminsdata.sentEmails}*/}
      {/*        meta={adminsdata.questionsMeta}*/}
      {/*        handleGotoNext={handleGoToNext}*/}
      {/*        handleGotoPrevious={handleGoToPrev}*/}
      {/*        currentPage={currentPage}*/}
      {/*      />*/}
      {/*    )}*/}
      {/*  </div>*/}
      {/*</TabletAndBelow>*/}
    </>
  );
};
